import axios from 'axios'

const userApi = axios.create({
  baseURL: import.meta.env.VITE_API_USER_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

userApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default userApi
